import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { adminForgotPassword } from '../../api/auth';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ForgotPassword = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setEmailError('');

        let isValid = true;
        // Email validation
        if (email === '') {
            setEmailError('Email is required.');
            isValid = false;
        } else if (!validateEmail(email)) {
            setEmailError('Invalid email format.');
            isValid = false;
        }

        if (isValid) {
            adminForgotPassword({ email }, dispatch, navigate, toast);
        }
    };
    
    return (
        <div className='w-screen h-screen flex justify-between items-center p-5 gap-5'>
            <div className='h-full basis-1/2 rounded-3xl py-5 flex flex-col items-center bg-[radial-gradient(_109.97%_217.38%_at_0%_0%,_#f2fff7_0%,_#a1fbc0_68.68%,_#81f7a9_100%_)]'>
                <div className='place-self-start flex justify-start items-center'>
                    <img src={require('../../utils/media/logo.png')} alt="climate crusaders" className='h-16' />
                    <h1 className='text-primary font-extrabold text-lg'>Climate Crusaders</h1>
                </div>
                <div className='h-full flex justify-center items-center'>
                    <img src={require('../../utils/media/login_page.png')} className='place-self-center' alt="" />
                </div>
            </div>
            <div className='rounded-3xl shadow-lg basis-1/2 flex flex-col justify-start items-center py-20 px-14'>
                <h1 className='text-primary text-4xl font-semibold'>Forgot Password</h1>
                <form action="" method='post' className='w-full my-10 flex flex-col'>
                    <div className="email flex flex-col w-full">
                        <span className={`${emailError ? 'text-red' : 'text-black'} font-bold text-base`}>Email</span>
                        <input
                            type="email"
                            name="email"
                            id="email"
                            required
                            placeholder='Enter Email'
                            className={`border ${emailError ? 'border-red' : 'border-secondary'} rounded-md px-3 py-2`}
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                        />
                        {
                            emailError &&
                            <p className={`${emailError ? 'text-red' : 'text-black'} inline text-base`}>
                                {emailError}
                            </p>
                        }
                    </div>
                    <button className='bg-primary self-end px-10 py-2 text-white text-base font-bold mt-10 rounded-md border hover:bg-white hover:border hover:text-primary' onClick={handleSubmit}>
                        Send Verification Code
                    </button>
                </form>
            </div>
            <ToastContainer 
                position = "bottom-right"
            />
        </div>
    )
}

export default ForgotPassword;